<template>
    <div class="pb-8px h-full flex flex-col ">
        <div class="header flex items-center gap-8px pb-16px cursor-pointer w-full" @click="handleBack"
            v-if="props.category && props.category.name">
            <el-icon class=" back-icon cursor-pointer">
                <ArrowLeft />
            </el-icon>
            <div class="title">{{ props.category.name }}</div>
        </div>
        <div class="imageList mb-16px" v-if="categoriesShow">
            <!-- <div class="menu-items" :class="{ active: selectedCategory === 'all' }"
                @click="handleCategorySelect('all')">
                全部
            </div> -->
            <div v-for="item in categoryList" :key="item.id" class="menu-items"
                :class="{ active: selectedCategory == item.id }" @click="handleCategorySelect(item.id)">
                {{ item.name }}
            </div>
        </div>
        <div v-if="listItems.length != 0" class="pageList overflow-auto"
            :class="{ 'h-[calc(100%-80px)]': categoriesShow }" ref="scrollRef" @scroll="onScroll">
            <div class="List">
                <div v-for="item in listItems" :key="item.id" class="image-item">
                    <elementItem :template="item" />
                </div>
            </div>
            <div v-if="loadingMore" class="py-8px text-center text-12px text-[#999]">加载中...</div>
            <div v-else-if="!hasMore" class="py-8px text-center text-12px text-[#999]">已无更多</div>
        </div>

        <div v-if="listItems.length === 0">
            <el-empty description="暂无数据" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { getVectorCategory, recommendations, getmaterials, getCollectionItems, getMaterialsItems, getVectorList } from '@/api/affairs'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty } from 'element-plus'

// @ts-ignore
import elementItem from './elementItem.vue'
const props = defineProps<{
    category?: any,
    searchShow?: boolean,
    categoriesShow?: boolean,
    type?: string,
    searchValue?: string,
}>()
const selectedCategory = ref('all') // 默认选中"全部"
const title = ref('')
let page = ref({
    pageNum: 1,
    pageSize: 30,
    type: 1,
})
const listItems = ref([]);
const pagetotle = ref(0);
const scrollRef = ref<HTMLElement | null>(null)
const loadingMore = ref(false)
const currentPage = ref(1)
const pageSize = ref(50)
const hasMore = ref(true)
const resetPagination = () => {
    page.value.pageNum = 1;
    pagetotle.value = 0;
    listItems.value = [];
}

const onScroll = (e: Event) => {
    const el = (e.target as HTMLElement) || scrollRef.value
    if (!el || !hasMore.value || loadingMore.value) return
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 16
    if (nearBottom) {
        currentPage.value += 1
        getlist(props.type != 'svg' ? (props?.category?.id || '') : selectedCategory.value, currentPage.value, true)
    }
}

let category_Id = ref('')
let keywords = '';
onMounted(async () => {
    currentPage.value = 1
    hasMore.value = true
    if (props.categoriesShow) {
        await getCategory()
        return
    }
    getlist((props?.category?.id || ''), currentPage.value, true)


    // getmaterialsList(props.categoriesElementList.id, true, '')
})
const categoryList = ref('')
const categoriesElementList = ref([])
const getCategory = async () => {
    getVectorCategory({ page: 1, size: 100, id: props?.category?.id || '' }).then(res => {
        categoryList.value = res.data.data.items
        selectedCategory.value = res.data.data.items[0]?.id || ''
        getlist(selectedCategory.value, currentPage.value, false)
        return
    })
}
const allpage = ref(1)
const getlist = (categoryId: string | number, pageNo = 1, append = false) => {
    const apiMap: Record<string, Function> = {
        collect: getCollectionItems,
        materials: getMaterialsItems,
        svg: getVectorList,
    };
    const apiFunc = apiMap[props.type as string] || getmaterials;
    loadingMore.value = append
    apiFunc({ page: pageNo, size: pageSize.value, category_id: categoryId, name: props.searchValue || '' }).then((res: any) => {
        const items = res?.data?.data?.items || []
        if (append) {
            listItems.value = listItems.value.concat(items)
        } else {
            listItems.value = items
        }
        allpage.value = res?.data?.data?.total_pages || allpage.value
        hasMore.value = pageNo < allpage.value
    }).finally(() => {
        loadingMore.value = false
    })
}






const emit = defineEmits<{
    back: []
}>()

const handleSearch = () => {

}

const handleBack = () => {
    emit('back')
}

const handleCategorySelect = (categoryId: string | number) => {
    selectedCategory.value = categoryId.toString()
    getlist(selectedCategory.value, 1, false)
    // resetPagination(); // 重置分页
    // if (categoryId === 'all') {
    //     getmaterialsList(props.categoriesElementList.id, true, '')
    // } else {
    //     getmaterialsList(categoryId, true, '')
    // }
    // selectedCategory.value = categoryId
    // emit('categorySelect', categoryId)
}

</script>
<style lang="scss" scoped>
.menu-items {
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
    background-color: #fff;
    margin-top: 1px;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    color: #666;
    padding: 4px 12px;
    height: 30px;

    &:hover {
        border-color: #2a66ff;
        color: #2a66ff;
    }

    &.active {
        background-color: #2a66ff;
        border-color: #2a66ff;
        color: #fff;
        height: 30px;
    }
}

.imageList {
    display: flex;
    gap: 4px;
    width: 100%;
    margin-top: 0 !important;
}

.List {

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
}

.pageList {
    // height: 500px;
    // max-height: calc();
    overflow: auto;
    // background: red;
}

.image-item {
    width: 100%;
}
</style>
<style>
.el-pagination.is-background .btn-next.is-active,
.el-pagination.is-background .btn-prev.is-active,
.el-pagination.is-background .el-pager li.is-active {
    background-color: #2a66ff;
    border-color: #2a66ff;
    color: #fff;
}
</style>